import '@firebase/app-check-compat';
//# sourceMappingURL=index.esm.js.map
